export const getCsrfToken = () =>
  localStorage.getItem("csrfToken") || undefined;
